import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=a734438c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=a734438c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a734438c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a734438c')) {
      api.createRecord('a734438c', component.options)
    } else {
      api.reload('a734438c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=a734438c&scoped=true&", function () {
      api.rerender('a734438c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FjZvep5eBrPq/JS/comp/DocBox.vue"
export default component.exports